import { FaUsers, FaAward, FaHandsHelping, FaWhatsapp, FaCheck, FaUsers as FaUsersSolid, FaCheckCircle, FaUsersCog } from 'react-icons/fa';
import '../styles/about.css';

const About = () => {
  const stats = [
    { number: '10+', label: 'Years Experience', icon: <FaAward className="stats-icon stats-icon-blue" /> },
    { number: '500+', label: 'Happy Customers', icon: <FaUsers className="stats-icon stats-icon-red" /> },
    { number: '100%', label: 'Satisfaction Guarantee', icon: <FaHandsHelping className="stats-icon stats-icon-green" /> },
  ];

  return (
    <div className="about-page">
      {/* Hero Section */}
      <section className="about-hero">
        <div className="about-hero-container">
          <h1 className="about-hero-title">About Joewaki Motors</h1>
          <p className="about-hero-subtitle">
            Delivering excellence in energy saving stoves & equipment solutions.
          </p>
        </div>
      </section>

      {/* About Section */}
      <section className="about-main">
        <div className="about-container">
          <div className="about-content">
            <div className="about-image-container">
              <img
                src="/small-burner-e8676c3a-8f86-417f-af1f-3c98c87fd456.png"
                alt="Our workshop"
                className="about-image"
              
              />
            </div>
            <div className="about-text">
              <h2 className="about-title">Our Story</h2>
              <p className="about-description">
                At Joewaki Motor Agency Limited, we provide a complete range of services designed to 
                support every customer who chooses our energy-saving jikos. 
                Our team offers professional installation to ensure that each stove is set up safely, 
                efficiently, and according to the customer’s specific needs—whether in schools, hotels, hospitals, or other institutions. 
                We also offer expert assembly services, carefully putting together every component to guarantee optimal performance and long-lasting durability. 
                In addition, we provide reliable maintenance and after-sale support to keep your jiko functioning at its best. This includes routine checkups, repairs, part replacements, and guidance on proper usage and care. 
                Our goal is to ensure that every client enjoys maximum fuel efficiency, safety, and comfort from our products. With a dedicated team, we are committed to delivering quality service that enhances your daily cooking experience and supports sustainable energy solutions.
              </p>
              <div className="stats-grid">
                {stats.map((stat, index) => (
                  <div key={index} className="stat-card">
                    {stat.icon}
                    <div className="stat-number">{stat.number}</div>
                    <div className="stat-label">{stat.label}</div>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Mission & Vision */}
      <section className="mission-vision">
        <div className="mission-container">
          <div className="section-header">
            <h2 className="section-title">Our Mission & Vision</h2>
            <div className="section-divider"></div>
          </div>
          
          <div className="mission-grid">
            <div className="mission-card">
              <h3 className="mission-title">Our Mission</h3>
              <p className="mission-text">
                To provide high-quality jikos and motor equipment solutions that enhance the lives of our customers while maintaining the highest standards of professionalism and integrity.
              </p>
              <ul className="mission-list">
                <li className="mission-list-item">
                  <FaCheck className="mission-icon" />
                  <span>Deliver exceptional quality and value</span>
                </li>
                <li className="mission-list-item">
                  <FaCheck className="mission-icon" />
                  <span>Prioritize customer satisfaction</span>
                </li>
                <li className="mission-list-item">
                  <FaCheck className="mission-icon" />
                  <span>Maintain the highest standards of service</span>
                </li>
              </ul>
            </div>
            
            <div className="vision-card">
              <h3 className="vision-title">Our Vision</h3>
              <p className="vision-text">
                To be the most trusted and preferred provider of jiko and motor equipment solutions, known for innovation, reliability, and exceptional customer service across the region.
              </p>
              <div className="core-values">
                <h4 className="core-values-title">Our Core Values</h4>
                <div className="values-list">
                  <div className="value-item">
                    <FaCheckCircle className="value-icon" />
                    <div className="value-content">
                      <h5 className="value-title">Excellence</h5>
                      <p className="value-description">Striving for the highest quality in everything we do</p>
                    </div>
                  </div>
                  <div className="value-item">
                    <FaUsersSolid className="value-icon" />
                    <div className="value-content">
                      <h5 className="value-title">Integrity</h5>
                      <p className="value-description">Doing what's right, even when no one is watching</p>
                    </div>
                  </div>
                  <div className="value-item">
                    <FaUsersCog className="value-icon" />
                    <div className="value-content">
                      <h5 className="value-title">Teamwork</h5>
                      <p className="value-description">Collaborating for shared success</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    
      {/* CTA Section */}
      <section className="about-cta">
        <div className="cta-container">
          <h2 className="text-3xl font-bold mb-6">Ready to Work With Us?</h2>
          <p className="text-xl mb-8 max-w-2xl mx-auto">
            Join our growing list of satisfied customers who trust us with their jiko and motor equipment needs.
          </p>
          <a
            href="https://wa.me/254721858828"
            target="_blank"
            rel="noopener noreferrer"
            className="inline-block bg-white text-blue-700 hover:bg-blue-50 px-8 py-3 rounded-lg font-semibold text-center transition-colors flex items-center justify-center mx-auto"
          >
            <FaWhatsapp className="mr-2" /> Get in Touch
          </a>
        </div>
      </section>
    </div>
  );
};

export default About;
